import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Field, reduxForm } from 'redux-form';
import Button from '../Button';
import {
  InputField, TinyMCEEditor
} from '../ReduxFormComponents';
import { GuideValidation } from '../../middlewares/formValidator';

const GuideForm = (props) => (
  <form onSubmit={props.handleSubmit}>
    <Field name="Id" component={InputField} type="hidden" className="form-control" />
    <div className="row form-group">
      <div className="col-md-6">
        <label className="text-left">Guide Name</label>
        <div>
          <Field name="Title" component={InputField} type="text" className="form-control" />
        </div>
      </div>
      <div className="col-md-6">
        <label className="text-left">Download URL</label>
        <div>
          <Field name="DownloadURL" component={InputField} type="text" className="form-control" />
        </div>
      </div>
    </div>
    <div className="row form-group">
      <div className="col-md-6">
        <label className="text-left">Slug URL</label>
        <div>
          <Field name="SlugURL" component={InputField} type="text" className="form-control" />
        </div>
      </div>
      <div className="col-md-6">
        <label className="text-left">Featured Image URL</label>
        <div>
          <Field name="FeaturedImageURL" component={InputField} type="text" className="form-control" />
        </div>
      </div>
    </div>
    <div className="row form-group mt-2">
      <div className="col-md-6">
        <label className="text-left">OrderNumber</label>
        <div>
          <Field name="OrderNumber" component={InputField} type="text" className="form-control" />
        </div>
      </div>
    </div>
    <div className="form-group ">
      <label>Description</label>
      <div>
        <Field
          name="Description"
          className="form-control"
          component={TinyMCEEditor}
          minHeight={250}
          inlineEditor
        />
      </div>
    </div>
    <div className="py-2 mt-2">
      <Button
        type="submit"
        className="btn btn-sm btn-success"
        loading={props.formLoading}
        loadingText="Saving..."
        disabled={props.pristine}
      >
        <i className="fas fa-save mr-1" />
        Save
      </Button>
      <Button
        onClick={props.reset}
        className="btn btn-sm btn-outline-secondary ml-2"
        disabled={props.pristine}
      >
        <i className="fas fa-redo mr-1" />
        Reset
      </Button>
    </div>
  </form>
);

GuideForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  reset: PropTypes.func.isRequired,
  formLoading: PropTypes.bool,
  formError: PropTypes.string,
  pristine: PropTypes.bool.isRequired
};

GuideForm.defaultProps = {
  formLoading: null,
  formError: null
};

const guideForm = reduxForm({
  form: 'Guide Form',
  validate: GuideValidation,
  initialValues: {},
  enableReinitialize: false
})(GuideForm);

const mapStateToProps = ({ guide }) => ({
  initialValues: guide.form
});

export default connect(mapStateToProps)(guideForm);
